export default {
  "article.title": "What Is a USFans Spreadsheet? A Complete Beginner's Guide",
  "article.meta_description": "Learn what a USFans spreadsheet is, why shoppers use it, how to organize one and what to check before you buy. A beginner-friendly guide with practical tips.",
  "article.breadcrumb_home": "Home",
  "article.breadcrumb_current": "USFans Spreadsheet Guide",
  "article.updated": "Last updated",
  "article.read_time": "6 min read",
  "article.toc": "Table of contents",
  "article.toc_1": "What is a USFans spreadsheet?",
  "article.toc_2": "Why use a spreadsheet when shopping?",
  "article.toc_3": "How to organize a USFans spreadsheet",
  "article.toc_4": "Common columns to include",
  "article.toc_5": "Tips for beginners",
  "article.toc_6": "Frequently asked questions",

  "article.intro": "A USFans spreadsheet is a structured resource that many shoppers use to organize, compare and keep track of products while browsing. This guide explains what a USFans spreadsheet is, why it can be helpful, how to set one up effectively, and what to keep in mind before you make a purchase.",

  "article.h2_1": "What is a USFans spreadsheet?",
  "article.p_1a": "In simple terms, a USFans spreadsheet is a table used to collect product information in one place. Instead of scrolling through a long catalog and trying to remember what you saw, you can record the items you are interested in — their category, reference, size, price and any notes about quality or shipping.",
  "article.p_1b": "The spreadsheet is not an official tool. It is a practical way to bring structure to your shopping research. Many people create their own version, adding only the columns that matter to them.",

  "article.h2_2": "Why use a spreadsheet when shopping?",
  "article.p_2a": "A spreadsheet helps in a few practical ways. First, it keeps all your options visible at once, so you can compare products side by side without opening many tabs. Second, it reduces the chance of forgetting an item you liked. Third, it gives you a clear record of what you are considering, which is useful if you plan to buy over several days.",
  "article.p_2b": "It is especially helpful when you are comparing similar products across categories — for example, checking how a jacket differs from a hoodie in terms of available sizes, references and notes.",

  "article.h2_3": "How to organize a USFans spreadsheet",
  "article.p_3a": "You do not need special software. A simple sheet in any spreadsheet app works well. Start with a header row that names each column, then add one row per product you are considering.",
  "article.p_3b": "Keep the layout simple. The goal is clarity, not complexity. You can always add or remove columns later as your needs change.",

  "article.h2_4": "Common columns to include",
  "article.table_header": "A practical starting layout",
  "article.table_col1": "Column",
  "article.table_col2": "What it is for",
  "article.row1_col1": "Product",
  "article.row1_col2": "The item name or description",
  "article.row2_col1": "Category",
  "article.row2_col2": "Shoes, hoodies, jackets, and so on",
  "article.row3_col1": "Reference",
  "article.row3_col2": "A code or SKU to identify the item",
  "article.row4_col1": "QC",
  "article.row4_col2": "Notes on quality check or inspection",
  "article.row5_col1": "Shipping",
  "article.row5_col2": "Shipping method or delivery notes",
  "article.row6_col1": "Status",
  "article.row6_col2": "Considering, ordered, or received",

  "article.h2_5": "Tips for beginners",
  "article.tip_1": "Start with a small list and add columns only when you need them.",
  "article.tip_2": "Use a consistent reference or SKU so you can find the same item again.",
  "article.tip_3": "Record the date and source of any information you note down.",
  "article.tip_4": "Keep price and shipping details as a note, then verify them on the main website before buying.",

  "article.faq_title": "Frequently asked questions",
  "article.faq_q1": "Do I need a special app to make a USFans spreadsheet?",
  "article.faq_a1": "No. Any spreadsheet or even a simple note works. The important part is a clear, consistent layout.",
  "article.faq_q2": "Is the spreadsheet an official USFans product?",
  "article.faq_a2": "No. It is a general organizing method used by shoppers, not an official tool from any seller.",
  "article.faq_q3": "How is this different from just browsing the catalog?",
  "article.faq_a3": "Browsing shows you products one by one. A spreadsheet lets you keep your shortlist together and compare it directly.",

  "article.cta_title": "Ready to put it into practice?",
  "article.cta_body": "Now that you understand how a USFans spreadsheet works, head over to the main website to browse products and start building your own list.",
  "article.cta_button": "Browse products on the main website",
  "article.back_home": "Back to home",
  "article.related_title": "Related resources",
  "article.related_1": "USFans Review",
  "article.related_2": "USFans Shipping Cost Guide",
  "article.related_3": "Is USFans Legit?",
};